import React from 'react'
import { Box, Typography } from '@mui/material'

import { typography } from '~tokens/internal'

import Icon from '../Icon'

import './SmsPreview.scss'

export interface SmsPreviewProps {
  message: string
  orgName?: string
}

const SmsPreview: React.FC<SmsPreviewProps> = ({ message, orgName = 'Your Organization' }) => {
  return (
    <Box className='sms-preview'>
      <Box className='sms-preview__frame'>
        <Box className='sms-preview__notch' />

        <Box className='sms-preview__screen'>
          <Box className='sms-preview__status-bar'>
            <Typography className='sms-preview__status-time'>9:41</Typography>
            <Typography className='sms-preview__status-signal'>●●●</Typography>
          </Box>

          <Box className='sms-preview__app-bar'>
            <Typography className='sms-preview__app-label'>Message</Typography>
            <Typography className='sms-preview__app-sender'>{orgName}</Typography>
          </Box>

          <Box className='sms-preview__message-area'>
            {message ? (
              <Box className='sms-preview__bubble-wrapper'>
                <Box className='sms-preview__bubble'>
                  <Typography className='sms-preview__bubble-text'>{message}</Typography>
                </Box>
              </Box>
            ) : (
              <Typography className='sms-preview__empty-message'>
                Your message preview will appear here
              </Typography>
            )}
          </Box>

          <Box className='sms-preview__input-bar'>
            <Box className='sms-preview__input-field' />
            <Box className='sms-preview__send-btn'>
              <Icon name='Send' size={typography.fontSizePx.xs} color='white' />
            </Box>
          </Box>
        </Box>

        <Box className='sms-preview__home-indicator' />
      </Box>
    </Box>
  )
}

export default SmsPreview
